/* eslint-disable react-hooks/exhaustive-deps */
import {CheckCircleOutlined, ColumnHeightOutlined, DownloadOutlined, PlusOutlined} from '@ant-design/icons'
import {Checkbox, Popover} from 'antd'
import {FC, useState} from 'react'
import {useMutation} from 'react-query'
import {Loading} from '../../../../../../_metronic/layout/components/loading/Loading'
import {BtnRefetch} from '../../../../../../components'
import {useAuth} from '../../../../../modules/auth/core/Auth'
import {ThietBiColumnsMeta} from '../../table/columns/ThietBiColumnsMeta'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useQueryResponse, useQueryResponseData} from '../../core/QueryResponseProvider'
import {ExportDeviceInfor2} from '../../core/_requests'
import DeviceModal from './DeviceModal'
import ThietBiNCCModal from './ThietBiNCCModal'

type Props = {
  changeTab: any
}
const DeviceInfoListSearchComponent: FC<Props> = ({changeTab}) => {
  const {auth} = useAuth()
  const data = useQueryResponseData()
  const {refetch} = useQueryResponse()
  const {state} = useQueryRequest()
  const [isLoading, setIsLoading] = useState(false)

  const [isModalOpen, setIsModalOpen] = useState(false)

  const [isModalApprovalOpen, setIsModalApprovalOpen] = useState(false)
  const [visibleColumns, setVisibleColumns] = useState<string[]>(() => {
    const saved = localStorage.getItem('tableColumns')
    return saved ? JSON.parse(saved) : ThietBiColumnsMeta.map((item) => item.key)
  })

  const showModal = () => {
    setIsModalOpen(true)
  }

  const showModalApproval = () => {
    setIsModalApprovalOpen(true)
  }

  const handleCancelApproval = () => {
    setIsModalApprovalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const updateVisibleColumns = (nextColumns: string[]) => {
    setVisibleColumns(nextColumns)
    localStorage.setItem('tableColumns', JSON.stringify(nextColumns))
    window.dispatchEvent(new Event('thietbiTableColumnsChanged'))
  }

  const Export = () => {
    setIsLoading(true)
    exportDevice2.mutateAsync()
  }

  const exportDevice2 = useMutation(() => ExportDeviceInfor2(auth?.configs, state), {
    onSuccess: (response) => {
      const url = window.URL.createObjectURL(new Blob([response]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `Danhsachthietbi.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsLoading(false)
    },
  })

  return (
    <>
      <BtnRefetch refetch={refetch} />
      <Popover
        placement='bottomRight'
        content={
          <div style={{minWidth: 260}}>
            {ThietBiColumnsMeta.map((column) => (
              <div key={column.key} className='mb-2'>
                <Checkbox
                  checked={visibleColumns.includes(column.key)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      updateVisibleColumns([...visibleColumns, column.key])
                    } else {
                      updateVisibleColumns(visibleColumns.filter((key) => key !== column.key))
                    }
                  }}
                >
                  {column.title}
                </Checkbox>
              </div>
            ))}
          </div>
        }
        trigger={['click']}
      >
        <button type='button' className='btn btn-light-primary me-3'>
          <ColumnHeightOutlined /> Ẩn/hiện cột
        </button>
      </Popover>
      <button type='button' className='btn btn-primary me-3' onClick={showModalApproval}>
        <CheckCircleOutlined /> Phê duyệt thiết bị
      </button>
      <button
        type='button'
        className='btn btn-primary me-3'
        onClick={Export}
        disabled={data.length === 0}
      >
        <DownloadOutlined />
        Xuất dữ liệu
      </button>
      <button type='button' className='btn btn-primary me-3' onClick={showModal}>
        <PlusOutlined />
        Thêm mới
      </button>
      <button
        type='button'
        className='btn btn-light-primary'
        title='Nhật ký hoạt động'
        onClick={() => changeTab(3)}
      >
        <i className='bi bi-clock-history' style={{paddingRight: 0}}></i>
      </button>
      {isLoading && <Loading />}
      {isModalApprovalOpen && (
        <ThietBiNCCModal
          handleCancel={handleCancelApproval}
          isModalSpeakerOpen={isModalApprovalOpen}
        ></ThietBiNCCModal>
      )}
      {isModalOpen && (
        <DeviceModal
          handleCancel={handleCancel}
          isModalOpen={isModalOpen}
          isElectronicBoard={false}
        />
      )}
    </>
  )
}

export {DeviceInfoListSearchComponent}
